import React from 'react';

import { Outlet, useParams } from 'react-router-dom';

import AnnouncementToast
  from '../components/common/AnnouncementToast/AnnouncementToast';
import { AnnouncementsProvider } from '../contexts/AnnouncementsContext';

const TryoutShell: React.FC = () => {
  const { tryoutId } = useParams<{ tryoutId: string }>();

  if (!tryoutId) return null;

  return (
    <AnnouncementsProvider tryoutId={tryoutId}>
      <AnnouncementToast />
      <Outlet />
    </AnnouncementsProvider>
  );
};

export default TryoutShell;
